import PropTypes from 'prop-types';
import ReactApexChart , {  Props } from 'react-apexcharts';
// @mui
import { useTheme, styled } from '@mui/material/styles';
import { Card, CardHeader } from '@mui/material';
// utils
import { fNumber } from '../../../utils/formatNumber';
// components
import { useChart } from '../../../components/chart';
// ----------------------------------------------------------------------

const CHART_HEIGHT = 372;
const LEGEND_HEIGHT = 72;

const StyledChartWrapper = styled('div')(({ theme }) => ({
  height: CHART_HEIGHT,
  marginTop: theme.spacing(5),
  '& .apexcharts-canvas svg': { height: CHART_HEIGHT },
  '& .apexcharts-canvas svg,.apexcharts-canvas foreignObject': {
    overflow: 'visible',
  },
  '& .apexcharts-legend': {
    height: LEGEND_HEIGHT,
    alignContent: 'center',
    position: 'relative !important',
    borderTop: `solid 1px ${theme.palette.divider}`,
    top: `calc(${CHART_HEIGHT - LEGEND_HEIGHT}px) !important`,
  },
}));

// ----------------------------------------------------------------------

// const chartData = {
//   series: [500, 600],

//   options: {
//     chart: { type: "donut" },
//     legend: { show: false },
//     dataLabels: { enabled: false },
//     tooltip: { enabled: false },
//     fill: { colors: ["#9B9B9B", "#7FD320"] },
//     states: {
//       hover: { filter: { type: "lighten", value: 0.5 } },
//       active: { filter: { type: "none", value: 0 } }
//     },
//     stroke: { width: 0 },
//     plotOptions: {
//       pie: {
//         expandOnClick: false,
//         donut: {
//           size: "75%",
//           labels: {
//             show: true,
//             name: { show: false },
//             total: {
//               show: true,
//               showAlways: true,
//               formatter: function (w) {
//                 const totals = w.globals.seriesTotals;

//                 const result = totals.reduce((a, b) => a + b, 0);

//                 return (result / 1000).toFixed(3);
//               }
//             }
//           }
//         }
//       }
//     }
//   }
// };

// AppCurrentVisits.propTypes = {
//   title: PropTypes.string,
//   subheader: PropTypes.string,
//   chartColors: PropTypes.arrayOf(PropTypes.string),
//   chartData: PropTypes.array,
// };
type AppCurrentVisitsProps ={
  title:string, 
  subheader?:string, 
  chartColors:string[], 
  // chartData, 
  nps:string,
  chartLabels:string[],
  chartSeries:Props['series']
}
export default function AppCurrentVisits({ title, subheader, chartColors, nps , chartLabels , chartSeries}:AppCurrentVisitsProps) {
  nps += '%';
  const theme = useTheme();

  // const chartLabels = chartData.map((i) => i.label);

  // const chartSeries = chartData.map((i) => i.value);

  const chartOptions = useChart({
    colors: chartColors,
    labels: chartLabels,
    stroke: { colors: [theme.palette.background.paper] },
    legend: { floating: true, horizontalAlign: 'center' },
    dataLabels: { enabled: true, dropShadow: { enabled: false } },
    tooltip: {
      fillSeriesColor: false,
      y: {
        formatter: (seriesName:number) => fNumber(seriesName),
        title: {
          formatter: (seriesName:number) => `${seriesName}`,
        },
      },
    },
    plotOptions: {
      pie: {
        donut: {
          labels: {
            show: true,
            name: {
              show: true,
              offsetY: -25,
              formatter() {
                return ['NPS'];
              },
            },
            value: {
              offsetY: -10,
            },
            total: {
              show: true,
              showAlways: true,
              formatter() {
                return [nps];
              },
            },
          },
        },
      },
    },
  });

  return (
    <Card >
      <CardHeader title={title} subheader={subheader} />

      <StyledChartWrapper dir="ltr">
        <ReactApexChart type="donut" series={chartSeries} options={chartOptions} height={280} />
      </StyledChartWrapper>
    </Card>
  );
}
